import { Property, PropertyService } from '..';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { RateBucketsService } from '../../rate-bucket/rate-bucket.service';
import { OccProfileService } from '../../occ-profile';
import { OccMap, OccMapService } from '../../occ-map';

@Component({
    selector: 'app-properties',
    templateUrl: './property.component.html',
    styleUrls: ['./property.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PropertiesComponent implements OnInit {
	statusType: any;
	countries: any;
	states: any;
	isSearching = false;
	rateBuckets: any[]=[];
	occProfiles: any[]=[];
	occMaps: any[]=[];
	ownerEnforceAmt: boolean = false;

	@Input() property: Property;
	@Input() propertyId: any;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	@Input() showFields = false;
	propertyTypes: any[];
	

	constructor(
		private constantService: ConstantService,
		private primengConfig: PrimeNGConfig,
		private propertyService: PropertyService,
		private alertService: AlertService,
		private rateBucketService: RateBucketsService,
		private occProfileService : OccProfileService,
		private occMapService : OccMapService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.property = data.property,
			this.statuses = propertyService.statuses;
			this.statusType = propertyService.statusType;
			this.propertyTypes = propertyService.propertyTypes;
			this.countries = this.constantService.countries; 
			this.states = this.constantService.states;
	}

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {

		propertyId: [],
		propertyCode: [],
		propertyName: [],
		createDate: [],
		lastUpdate: [],
		developmentName: [],
		websiteURL: [],
		locationId: [],
		adrType: [],
		adrStreet: [],
		adrStreet2: [],
		adrUnit: [],
		adrBuilding: [],
		adrComplex: [],
		adrDistrict: [],
		adrCity: [],
		adrCounty: [],
		adrMetro: [],
		adrCountry: [],
		adrRegion: [],
		adrState: [],
		adrPostCode: [],
		adrIsland: [],
		crossStreet: [],
		longitude: [],
		latitude: [],
		locale: [],
		propertyType: [], // SFR, // etc.
		yearBuilt: [],
		floorOfProperty: [],
		floorsInBuilding: [],
		sizeInterior: [],
		sizeExterior: [],
		sizeUnit: [],
		numBedrooms: [],
		numBathrooms: [],
		sleepsMax: [],
		sleepsMaxInBeds: [],
		listingStatus: [], // 1=active, 2=suspended, 3=archived
		listingType: [], // 1=str, 2=composite, 3=hotel
		hotelRoomType: [],
		mgmtCommissionPct: [],
		minNightlyRate: [],
		ownerEnforced: [],
		maxNightlyRate: [],
		minLengthOfStay: [],
		maxLengthOfStay: [],
		annualRevTargetAmnt: [],
		rateBucketAdjustmentPct: [],
		vrboId: [],
		extSystemId: [], // shortTermRentalId
		extSystemName: [], // wiki
		rateBucketId:[],
		occProfileId:[],
		occMapId:[],
		rateBucketName: []
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		if(this.property == undefined || this.property == null){
			this.getPropertyByPropertyId();
		}
		this.getAllRateBuckets();
		this.getAllOccProfiles();
		this.getAllOccMaps();

		// if we were passed the whole property object
		if (this.property) {
			this.propertyId = this.property.propertyId;
			this.fixDates();
			this.form1.patchValue(this.property);
		}
	}

	getPropertyByPropertyId() {
		try {
			this.propertyService.findById(this.propertyId)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.property = res.data.property;

						this.form1.patchValue(this.property);
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.propertyId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.propertyService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.property = res.data.property;
						this.doAdd.emit(this.property);
					},
					(err: any) => {
						console.log('property-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('property: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.propertyService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.property = res.data.property;
						this.doUpdate.emit(this.property);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.propertyService.delete(this.property.propertyId)
				.subscribe(
					(res: any) => {
						console.log('property-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.property);
					},
					(err: any) => {
						console.log('property-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	//Generate Nightly rates
	generateRate(propertyId: any) {
		try {
			this.propertyService.generateRateByProperty(propertyId)
				.subscribe(
					res => {
						
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rates are being generated in background. Please wait 1-3 minutes.  Do not press GENERATE RATES again.', life: 3000 });
	}


	generateRateLos(propertyId: any) {
		try {
			this.propertyService.generateRateLosByProperty(propertyId)
				.subscribe(
					res => {
						
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rates are being generated in background. Please wait 1-3 minutes.  Do not press GENERATE RATES again.', life: 3000 });
	}

	yieldMaxSurgicalDeleteRateLos(propertyId: any) {
		try {
			this.propertyService.yieldMaxSurgicalDeleteRateLos(propertyId)
				.subscribe(
					res => {
						
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rates are being deleted in background. Please wait 1-2 minutes. Do not press Delete Rate LOS again.', life: 3000 });
	}

	yieldMaxDeleteAndRegenerateAllLosConfirmation(propertyId: any) {
		this.confirmationService.confirm({
			message: 'Are you sure? This will DELETE all LOS records from YM and Wiki and Regenerate again.',
			header: 'Confirmation',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.yieldMaxDeleteAndRegenerateAllLos(propertyId);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete LOS canceled.', life: 1000 });
			}
		});
	}

	yieldMaxDeleteAndRegenerateAllLos(propertyId: any) {
		try {
			this.propertyService.yieldMaxDeleteAndRegenerateAllLos(propertyId)
				.subscribe(
					res => {
						
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rates are being deleted in background. Please wait 3-4 minutes. Do not press Delete Rate LOS again.', life: 3000 });
	}

	wikiSurgicalDeleteRateLos(extSystemId: any) {
		try {
			this.propertyService.wikiSurgicalDeleteRateLos(extSystemId)
				.subscribe(
					res => {
						
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rates are being deleted in background. Please wait 1-2 minutes. Do not press Delete Rate LOS again.', life: 3000 });
	}

	onCheckboxChange(event)
	{
		this.form1.get('ownerEnforced')?.setValue(event.checked);
		this.ownerEnforceAmt = event.checked;
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			propertyId: [],
			propertyCode: [],
			propertyName: [],
			createDate: [],
			lastUpdate: [],
			developmentName: [],
			websiteURL: [],
			locationId: [],
			adrType: [],
			adrStreet: [],
			adrStreet2: [],
			adrUnit: [],
			adrBuilding: [],
			adrComplex: [],
			adrDistrict: [],
			adrCity: [],
			adrCounty: [],
			adrMetro: [],
			adrCountry: [],
			adrRegion: [],
			adrState: [],
			adrPostCode: [],
			adrIsland: [],
			crossStreet: [],
			longitude: [],
			latitude: [],
			locale: [],
			propertyType: [], // SFR, // etc.
			yearBuilt: [],
			floorOfProperty: [],
			floorsInBuilding: [],
			sizeInterior: [],
			sizeExterior: [],
			sizeUnit: [],
			numBedrooms: [],
			numBathrooms: [],
			sleepsMax: [],
			sleepsMaxInBeds: [],
			listingStatus: [], // 1=active, 2=suspended, 3=archived
			listingType: [], // 1=str, 2=composite, 3=hotel
			hotelRoomType: [],
			mgmtCommissionPct: [],
			minNightlyRate: [],
			ownerEnforced: [false],
			maxNightlyRate: [],
			minLengthOfStay: [],
			maxLengthOfStay: [],
			annualRevTargetAmnt: [],
			rateBucketAdjustmentPct: [],
			vrboId: [],
			extSystemId: [], // shortTermRentalId
			extSystemName: [], // wiki
			rateBucketId:[],
			occProfileId:[],
			occMapId:[],
			rateBucketName:[]
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.property.propertyDate = moment(this.property.propertyDate).toDate();
	}

	syncReservationsByProperty() {
		try {
			this.propertyService.syncReservationsByProperty(this.propertyId)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Sync All Properties successfully', life: 3000 });
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	syncPropertyById() {
		try {
			this.propertyService.syncPropertyById(this.propertyId)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Sync All Properties successfully', life: 3000 });
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	syncReservationsByPropertyConfirmation() {
		this.confirmationService.confirm({
			message: 'This process will take 1-3 minutes to complete and run in background.  Do not press SYNC RESERVATIONS again.',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.syncReservationsByProperty();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	syncPropertyByIdConfirmation() {
		this.confirmationService.confirm({
			message: 'This process will take 1 minute to complete and run in background.  Do not press SYNC PROPERTY again.',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.syncPropertyById();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	getAllRateBuckets() {
		try {
			this.rateBucketService.getAllRateBuckets()
				.subscribe(
					res => {
						this.rateBuckets = res.data.rateBuckets;
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	getAllOccProfiles() {
		try {
			this.occProfileService.findAll()
				.subscribe(
					res => {
						this.occProfiles = res.data.occProfiles;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	getAllOccMaps() {
		try {
			this.occMapService.findAll()
				.subscribe(
					res => {
						this.occMaps = res.data.occMaps;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
}
